'use strict';

exports.toCallback = function (doWork) {
  return function (input, callback) {
    var res;

    try {
      res = doWork(input);
    } catch (err) {
      process.nextTick(callback, err);
      return;
    }

    process.nextTick(callback, null, res);
  };
};

exports.toBuf = function (doWork, other) {
  return function (input) {
    var result = doWork(input, other);
    return Buffer.from(result, 'hex');
  };
};

exports.fromString = function (doWork, other) {
  return function (_input) {
    var input = Buffer.isBuffer(_input) ? _input.toString() : _input;
    return doWork(input, other);
  };
};

exports.fromNumberTo32BitBuf = function (doWork, other) {
  return function (input) {
    var number = doWork(input, other);
    var bytes = new Array(4);

    for (var i = 0; i < 4; i++) {
      bytes[i] = number & 0xff;
      number = number >> 8;
    }

    return Buffer.from(bytes);
  };
};